export default __webpack_public_path__ + "static/media/goopter-digital-ordering-solution.a90bd494.png";